<script>
import Layout from "@layouts/auth";

export default {
  page: {
    title: "404",
    meta: [{ name: "description", content: "404" }]
  },
  components: { Layout },
  props: {
    resource: {
      type: String,
      default: ""
    }
  }
};
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card">
          <div class="card-body p-4">
            <div class="text-center">
              <h3 class="mt-4 font-weight-bold">
                404 - Página não encontrada
              </h3>
              <p class="text-muted mb-0 mt-3" style="line-height: 20px;">
                A página solicitada não existe. Por favor, verifique o endereço
                ou clique no botão abaixo para voltar à páginal principal.
              </p>

              <router-link tag="a" to="/" class="btn btn-primary mt-3"
                ><i class="mdi mdi-reply mr-1"></i>Voltar</router-link
              >
            </div>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
  </Layout>
</template>

<style lang="scss" module>
.title {
  text-align: center;
}
</style>
